import types from '../actionTypes';

const initialState = {
    activePinId: null,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case types.SET_MAP: {
            return {
                ...state,
                ...action.payload,
            };
        }
        default:
            return state;
    }
};
